<template>
  <input 
    type="password" 
    ref="input" 
    :value="value" 
    @input="$emit('input', $refs.input.value)"
  >
</template>

<script>
export default {
  name: 'iPasswordField',
  props: ['value'],
};
</script>

